import React from 'react';
import { Card, Grid, Paper, Typography, Stack, Box } from '@mui/material';

const InfoCard = ({title, subTitle="", value='...', onclick, theme, icon, type}) => {

  function onCardClick() {
    if(typeof onclick === 'function') onclick(type || title);
  }

  return (
    <Card className={`dashboard-card ${theme}`} onClick={onCardClick}>
      <Paper sx={{p: 2, backgroundColor: 'transparent'}}>
        {/* <Grid container columnSpacing={4} rowSpacing={2} > */}
        <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
          <Typography variant="h4"  component="h5" className="dashboard-card-value" color="white">
            {value}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
          <Stack direction="row" spacing={2}>
            <Box>
              <Typography variant="subtitle2"  component="h6" className='dashboard-card-title' color="white">
              {title}
            </Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
          <Typography variant="body2" gutterBottom component="p" className="dashboard-card-subtitle" color="white">
            {subTitle}
          </Typography>
        </Grid>
        {icon ? <Box sx={{
          width: 70,
          color: '#fff',
          position: 'absolute',
          fontSize: '12px',
          top: 10,
          right: '30px',
          opacity: .20,
        }}>
          {icon}
        </Box>: null}
        {/* </Grid> */}
      </Paper>
    </Card>
  );
} 

export default InfoCard;
